import React from 'react';
import TouristIcon from '@material-ui/icons/PersonOutline';
import TextField from '../TextField';
import { makeStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import { pluralizeI18n, _T } from 'appI18n';
import appSettings from '../../appSettings';
const useStyles = makeStyles(theme => ({
    root: {
        cursor: 'pointer',
        display: 'inline-block',
    },
    value: {
        display: 'flex',
        alignItems: 'center',
        '& svg': {
            display: 'inline-block',
            marginRight: 8,
        }
    },
    fullWidth: {
        width: '100%'
    },
    borderless: {
        border: 0,
        borderRadius: 0
    },
}));
export function TouristPickerTextField(props) {
    return TouristPickerTextFieldBase(props);
}
export function TouristPickerWithPlaceTextField(props) {
    return TouristPickerTextFieldBase(props);
}
function TouristPickerTextFieldBase(props) {
    const classes = useStyles();
    const adultsPlural = pluralizeI18n('adults', props.adultCount);
    const childrenPlural = pluralizeI18n('children', props.childAges.length);
    const rootClasses = `${classes.root} ${props.fullWidth ? classes.fullWidth : ''}` +
        ` ${props.borderless ? classes.borderless : ''}` +
        ` ${props.className || ''}`;
    const value = appSettings().tourSearchMaxChildCount ? `${props.adultCount} ${adultsPlural} · ${props.childAges.length} ${childrenPlural}` : `${props.adultCount} ${adultsPlural}`;
    return (React.createElement("div", { className: rootClasses, onClick: props.onClick },
        React.createElement(TextField, { label: _T.COMMON_TOURISTS, value: value, fullWidth: true, borderless: props.borderless, InputLabelProps: props.labelProps, InputProps: {
                startAdornment: React.createElement(InputAdornment, { position: "start" },
                    React.createElement(TouristIcon, null)),
                readOnly: true
            }, masqueradeAsSelect: true, required: props.required, error: props.error, helperText: props.error && props.errorText ? props.errorText : undefined })));
}
